
import CardOverflowContainer from '../molecule/CardOverflowContainer.vue';
import UIPostTickerCard from '../molecule/UIPostTickerCard.vue';
import AddIcon from '../icons/AddIcon.vue';
import UIPostTickerCardSkeleton from '../atom/skeleton/UIPostTickerCardSkeleton.vue';

export default {
  name: 'UIPostTickerList',
  components: {
    CardOverflowContainer,
    UIPostTickerCard,
    AddIcon,
    UIPostTickerCardSkeleton,
  },
  props: {
    tickers: {
      type: Array,
      required: true,
    },
    showAddButton: {
      type: Boolean,
      default: false,
    },
    showRemoveIcon: {
      type: Boolean,
      default: false,
    },
    withTopPadding: {
      type: Boolean,
      default: true,
    },
    showCardSkeleton: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['removeTicker', 'onAddClick', 'onCardClick'],
  data() {
    return {
      touchStartX: 0,
      touchStartY: 0,
    };
  },
  methods: {
    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
    },
    handleTouchMove(e) {
      const deltaX = Math.abs(e.touches[0].clientX - this.touchStartX);
      const deltaY = Math.abs(e.touches[0].clientY - this.touchStartY);

      // If horizontal movement is dominant, stop propagation towards Swiper
      if (deltaX > deltaY) {
        e.stopPropagation();
      }
    },
  },
};
